<script>
import { SatcomStateEnum, SatcomNetworkEnum } from "@/utils/enums";

export default {
  props: {
    item: Object
  },
  data() {
    return {
      SatcomNetworkEnum
    };
  },
  methods: {
    satcomIconColor(state) {
      switch (state) {
        case SatcomStateEnum.MISCONFIGURED:
          return "red";
        default:
          return "grey";
      }
    },
    isSatcomIRIDIUM(item) {
      if (
        !item.satcom_details.satcom_network &&
        item.satcom_details.satcom_network !== SatcomNetworkEnum.IRIDIUM
      )
        return false;

      return true;
    }
  }
};
</script>

<template>
  <div>
    <v-icon :color="satcomIconColor(item.satcom_state)">
      mdi-satellite-variant
    </v-icon>
    <div v-if="item.satcom_details">
      <div class="caption" v-if="isSatcomIRIDIUM(item)">
        {{ $t("modules.logs.messagingLog.network.iridium") }}
      </div>
      <div class="caption">
        {{ item.satcom_details.satcom_imei || null }}
      </div>
    </div>
  </div>
</template>
